import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AppFooterComponent } from "../shared/app-footer/app-footer.component";

@Component({
  selector: "unsubscribe-newsletter",
  templateUrl: "./unsubscribe-newsletter.component.html",
  styleUrls: ["./unsubscribe-newsletter.component.scss"],
})
export class UnsubscribeNewsletterComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AppFooterComponent>,
  ) {}

  ngOnInit(): void {}

  wfa_pstMesgFrmFom(evt) {
    if (
      evt.origin === "https://crm.zoho.in" ||
      evt.origin === "https://crm.zohopublic.in"
    ) {
      var loc_obj = JSON.stringify({
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
      });
      evt.source.postMessage(
        "prnt_wnd_pg_lc_rc_frm_prwindow_" + loc_obj,
        evt.origin
      );
    }
  }
    //  window.addEventListener('message', wfa_pstMesgFrmFom, false);

    onNoClick(): void {
      this.dialogRef.close();
    }
}
